import { HeadType } from 'components/layout/table/head'

export default (vat: string) => ({
  head: [
    {
      label: null,
      key: 'blank',
      col: 6,
      type: HeadType.Blank,
    },
    {
      label: 'Summe netto',
      key: 'totalPriceNetto',
      col: 2,
      unit: 'EUR',
    },
    {
      label: `MwSt. (${vat} %)`,
      key: 'tax',
      col: 2,
      unit: 'EUR',
    },
    {
      label: '= Gesamt brutto',
      key: 'totalPriceBrutto',
      col: 2,
      type: HeadType.Highlight,
      unit: 'EUR',
    },
  ],
  isAggregation: true,
  big: true,
})
